export default [
  {
    path: "complaint-emisor/confirm",
    component: () => import("@/views/customer/complaint-emisor/Confirm.vue"),
    meta: {
      breadcrumb: [
        { label: "Inicio", link: "/" },
        { label: "Queja contra un emisor de valores" },
      ],
    },
  },
  {
    path: "complaint-emisor/completed",
            name: 'RegisteredComplaintEmisorCustomer',
        props: true,
    component: () =>  import("@/views/shared/RegisteredComplaintEmisorCustomer.vue"),
    meta: {
      breadcrumb: [
        { label: "Inicio", link: "/" },
        { label: "Queja contra un emisor de valores" },
      ],
    },
  },
  {
    path: "complaint-emisor/registration",
    component: () =>
      import("@/views/customer/complaint-emisor/Registration.vue"),
    props: true,
    meta: {
      breadcrumb: [{ label: "Inicio", link: "/" }, { label: "Formulario" }],
    },
  },
];
